import { NgModule } from '@angular/core';
import { ToastrModule, ToastContainerModule as ToastrContainerModule } from 'ngx-toastr';
import { ToastContainerComponent } from './toast-container.component';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule,
    ToastrModule,
    ToastrContainerModule,
  ],
  declarations: [ToastContainerComponent],
  exports: [ToastContainerComponent],
  providers: []
})
export class ToastContainerModule {
}
